<script>
export default {
	name: 'RTabs',
	props: {
		active: {
			type: String,
			default: ''
		}
	},
	computed: {
		activeName: {
			get() {
				return this.active
			},
			set(val) {
				// if(val === this.active) return
				// this.$emit('update:active', val)
			}
		}
	}
}
</script>

<template>
	<el-tabs v-model="activeName" v-bind="$attrs">
		<slot></slot>
	</el-tabs>
</template>

<style scoped lang="scss">
/deep/ .el-tabs__nav-wrap::after {
	background-color: transparent;
}
/deep/ .el-tabs__active-bar {
	background: linear-gradient(to right, #ff5e2a, transparent);
}
/deep/ .el-tabs__item {
	font-size: 20px;
}
</style>
